import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { sortData, columns } from "./data";
import "./properties-table.css";

let pseudoCheckBoxSelectedData = [];

function PropertiesTable({ data, setScreen, page, setPage, setCheckBoxSelectedData, setcsvData }) {
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function makeChecboxComeAlive(event) {
    if (
      pseudoCheckBoxSelectedData.find(
        (e) =>
          e.property_code ===
          event?.target?.closest(".MuiTableRow-root").children[1].textContent.trim()
      )
    ) {
      pseudoCheckBoxSelectedData = pseudoCheckBoxSelectedData.filter(
        (e) =>
          e.property_code !==
          event?.target?.closest(".MuiTableRow-root").children[1].textContent.trim()
      );
      setCheckBoxSelectedData(pseudoCheckBoxSelectedData);
      setcsvData([
        [
          "Property Code",
          "Property Type",
          "Address",
          "No. of Units",
          "No. of Residents",
          "Ocuppied Status",
          "Date Created",
        ],
        ...pseudoCheckBoxSelectedData?.map(
          ({
            property_code,
            property_type,
            full_address,
            number_of_units,
            residents,
            occupied,
            createdAt,
          }) => {
            return [
              property_code,
              property_type,
              full_address?.house_number +
                " " +
                full_address?.street_name +
                " " +
                full_address?.city +
                " " +
                full_address?.state +
                " ",
              number_of_units,
              residents?.length,
              occupied,
              new Date(createdAt),
            ];
          }
        ),
      ]);
    } else {
      pseudoCheckBoxSelectedData.push(
        data?.find(
          (e) =>
            e?.property_code ===
            event?.target?.closest(".MuiTableRow-root").children[1].textContent.trim()
        )
      );
      setCheckBoxSelectedData(pseudoCheckBoxSelectedData);
      setcsvData([
        [
          "Property Code",
          "Property Type",
          "Address",
          "No. of Units",
          "No. of Residents",
          "Ocuppied Status",
          "Date Created",
        ],
        ...pseudoCheckBoxSelectedData?.map(
          ({
            property_code,
            property_type,
            full_address,
            number_of_units,
            residents,
            occupied,
            createdAt,
          }) => {
            return [
              property_code,
              property_type,
              full_address?.house_number +
                " " +
                full_address?.street_name +
                " " +
                full_address?.city +
                " " +
                full_address?.state +
                " ",
              number_of_units,
              residents?.length,
              occupied,
              new Date(createdAt),
            ];
          }
        ),
      ]);
    }
  }

  useEffect(() => {
    document.querySelectorAll("#property-checkbox-children").forEach((element) => {
      if (
        pseudoCheckBoxSelectedData.find(
          (e) =>
            e.property_code === element?.closest(".MuiTableRow-root").children[1].textContent.trim()
        )
      ) {
        element.checked = true;
      } else element.checked = false;
    });
  });

  function allActionPropertiesTable(add) {
    if (add) {
      pseudoCheckBoxSelectedData.length = 0;
      document.querySelectorAll("#property-checkbox-children").forEach((element) => {
        pseudoCheckBoxSelectedData.push(
          data?.find(
            (e) =>
              e?.property_code ===
              element?.closest(".MuiTableRow-root").children[1].textContent.trim()
          )
        );
        element.checked = true;
      });

      setCheckBoxSelectedData(pseudoCheckBoxSelectedData);
      setcsvData([
        [
          "Property Code",
          "Property Type",
          "Address",
          "No. of Units",
          "No. of Residents",
          "Ocuppied Status",
          "Date Created",
        ],
        ...pseudoCheckBoxSelectedData?.map(
          ({
            property_code,
            property_type,
            full_address,
            number_of_units,
            residents,
            occupied,
            createdAt,
          }) => {
            return [
              property_code,
              property_type,
              full_address?.house_number +
                " " +
                full_address?.street_name +
                " " +
                full_address?.city +
                " " +
                full_address?.state +
                " ",
              number_of_units,
              residents?.length,
              occupied,
              new Date(createdAt),
            ];
          }
        ),
      ]);
    } else {
      pseudoCheckBoxSelectedData.length = 0;
      document.querySelectorAll("#property-checkbox-children").forEach((element) => {
        element.checked = false;
      });
      setcsvData([
        [
          "Property Code",
          "Property Type",
          "Address",
          "No. of Units",
          "No. of Residents",
          "Ocuppied Status",
          "Date Created",
        ],
        ...data?.map(
          ({
            property_code,
            property_type,
            full_address,
            number_of_units,
            residents,
            occupied,
            createdAt,
          }) => {
            return [
              property_code,
              property_type,
              full_address?.house_number +
                " " +
                full_address?.street_name +
                " " +
                full_address?.city +
                " " +
                full_address?.state +
                " ",
              number_of_units,
              residents?.length,
              occupied,
              new Date(createdAt),
            ];
          }
        ),
      ]);
    }
  }

  if (!data) return;

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", height: "fit-content" }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  onClick={(e) => {
                    if (e.target.className.includes("property-table-checkboxes-head")) {
                      if (!e.target.checked) allActionPropertiesTable(false);
                      else allActionPropertiesTable(true);
                    }
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortData(data)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, i) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          style={{ cursor: "pointer" }}
                          onClick={(event) => {
                            if (event.target.className.includes("property-table-checkboxes")) {
                              event.stopPropagation();
                              return makeChecboxComeAlive(event);
                            }
                            setScreen({
                              screen: "details",
                              detailsID: event.target
                                .closest(".MuiTableRow-root")
                                ?.children[1]?.textContent.trim(),
                              residentsTableData: null,
                            });
                          }}
                          key={column.id}
                          align={column.align}
                        >
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={sortData(data).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export { PropertiesTable, pseudoCheckBoxSelectedData };
